import { DecisionAction } from "shared/types";

import Approve from "./assets/approve.svg?react";
import Decline from "./assets/decline.svg?react";
import ConditionalApprove from "./assets/conditional_approve.svg?react";

export const RuleBaseGraph = ({
  recommendation,
  className = "h-5 w-5"
}: {
  recommendation?: DecisionAction | null;
  className?: string;
}) => {
  switch (recommendation) {
    case DecisionAction.Approve:
      return <Approve className={className} />;
    case DecisionAction.Decline:
      return <Decline className={className} />;
    case DecisionAction.ConditionalApprove:
      return <ConditionalApprove className={className} />;
    default:
      return null;
  }
};
